<template lang="pug">
  .container
    .header
      img.banner(src="../../../public/images/xinjiang/janflow-header.png")
      el-form.mobile-form
        el-form-item
          el-input(type="text", v-model="form.mobile", placeholder="请输入新疆移动手机号")
        el-form-item(v-if="isCheckMobile")
          el-row
            el-col(:span="13")
              el-input(type="text", placeholder="请输入短信验证码", v-model="form.verifyCode", maxlength="6")
            el-col(:span="9", :offset="1")
              el-button(type="warning", :disabled="leftSendTime > 0", @click="sendVerifyCode")
                span(v-if="leftSendTime <= 0") 获取验证码
                span(v-else) {{leftSendTime}}秒后可重试
    .bottom
      el-button(v-if="!isCheckMobile", type="warning", @click="checkMobile") 限时领取
      el-button(v-else, type="warning", @click="showConfirm") 确定办理
    .img-desc
      img(src="../../../public/images/xinjiang/janflow-rights.png")
    .notice
      ul
        li(v-for="(notice, index) in notices", :key="index")
          .num {{index + 1}}.
          p.content {{notice}}
    el-dialog(
      width="80%",
      title="提示",
      :visible.sync="dialogVisible",
      :before-close="handleClose"
    )
      .dialog-content
        div
          | 您要为手机号：
          span.mobile-info {{form.mobile}}
        div
          | 办理业务：
          span.package-info {{selectedPackage.confirmInfo}}
      span.dialog-footer(slot="footer")
        el-button(@click="dialogVisible = false") 取消
        el-button(type="primary", @click="handleSubmit") 确定
    .share-dialog(v-if="shareNoticeVisiable", @click="shareNoticeVisiable = false")
      img(src="../../assets/images/shaanxi/share-dialog.png")
</template>

<script>

// 推啊=TUIA、豆盟=DOUMENG、快手=KUAISHOU
export default {
  data() {
    return {
      errlog: '',
      shareNoticeVisiable: false,
      dialogVisible: false,
      leftSendTime: 0,
      isCheckMobile: false,
      channel: 'TUIA',
      form: {
        carrierId: 13,
        mobile: '',
        verifyCode: '',
        userId: null,
        sharerId: null
      },
      notices: [
        '活动仅限新疆移动用户办理。',
        '活动期间，办理的5G权益合约包优惠购-12个月，包含原5G权益合约包-12个月业务，月功能费30元，长期有效，含国内流量5GB通用流量，12个月内可领取8次互联网月会员。',
        '合约说明：活动办理立即生效，合约期12个月，一个手机号码12个月内仅能订购一次，合约期享每月返还15元话费，返还话费不可用于冲抵违约金，合约期内不允许退订原业务。如您计划在合约期满后不再使用，请在合约到期当月可拨打10086申请退订。',
        '互联网月会员包含：5G权益：爱奇艺、优酷、腾讯视频、芒果TV、哔哩哔哩、咪咕视频、快手快币100枚；在线音乐类：酷狗音乐、QQ音乐、酷我音乐、咪咕音乐、网易音乐；阅读听书类：掌阅、喜马拉雅、QQ阅读、咪咕阅读、蜻蜓FM。可通过下载并登录中国移动APP，进入“权益”-“5G套内权益”-“我的权益”即可选择您需要的权益领取。',
        '使用范围：产品包含5GB通用流量，订购立即生效，按月自动续订，变更、退订次月生效。流量当月有效，不可结转、不可共享、不可转赠。使用范围：全国2/3/4/5G流量（不含港澳台），5G网速需具备5G网络及5G终端，并满足归属地运营商规定的其他使用条件。服务示例：张先生5月订购本产品，5月立即生效并收取费用，6月业务自动续订且收费。如张先生后续不再使用，可在6月退订本产品。7月起不再续订及收费。',
        '温馨提示：订购产品与您当前基础套餐存在互斥将可能导致办理失败；续订则和您当前主套餐档次相关；办理5G权益合约包不可回溯办理前已产生流量。其他规则可详询当地10086。',
        '订购如下原始2G套餐用户，包括但不限于神州行手机流量20元套餐、手机上网GPRS优惠时尚套餐、动感地带手机流量20元不限量套餐等，可能无法享受4、5G网络，建议先变更套餐再继续订购。',
        '5G网速需具备5G网络及5G终端，并满足归属地运营商规定的其他使用条件；',
        '本产品为通用流量月包产品，流量优先级高于主套餐套内通用流量，低于用户订购的定向流量包、流量小时包、日包、假日流量包。'
      ],
      selectedPackage: {},
      packageList: [
        {
          goodsCode: 'TUIA20210113001',
          confirmInfo: '5G权益优惠包，8个月热门软件VIP'
        }
      ]
    }
  },
  mounted() {
    this.handleSelected(this.packageList[0])
  },
  methods: {
    handleSelected(selectedPackage) {
      this.selectedPackage = selectedPackage
    },
    sendVerifyCode() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.$service.CarrierService
        .sendVerifyCode({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel
        })
        .then(res => {
          if (res.data.success) {
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    showConfirm() {
      this.dialogVisible = true
    },
    checkMobile() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel,
          goodsCode: this.selectedPackage.goodsCode,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.isCheckMobile = true
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    handleSubmit() {
      this.dialogVisible = false
      this.form.mobile = this.form.mobile.trim()
      this.form.verifyCode = this.form.verifyCode.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 6) {
        this.$message({
          type: 'warning',
          message: '请填写6位验证码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.selectedPackage.goodsCode,
          verifyCode: this.form.verifyCode,
          channel: this.channel,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.addMobilePackage()
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    addMobilePackage() {
      let _formData = {
        carrierId: this.form.carrierId,
        mobile: this.form.mobile,
        userId: this.form.userId || 25995,   // 缺省冀的用户ID,
        goodsCode: this.selectedPackage.goodsCode,
        verifyCode: this.form.verifyCode,
        channel: this.channel
      }
      if (this.form.sharerId) {
        _formData.sharerId = this.form.sharerId
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在办理业务',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .addMobilePackage(_formData)
        .then(res => {
          if (res.data.success) {
            try{
              // eslint-disable-next-line
              if (window.countLog) {
                // eslint-disable-next-line
                countLog.ready(function() {
                  // eslint-disable-next-line
                  countLog.init(function() { 
                    // 如果需要跳转，在此处写入 window.location.href = 跳转链接 
                  }, {
                    // 是否需要复制订单号，是为 1，不是为 0 
                    isCopy: 0, 
                    // 上报转化类型，具体见下表 
                    pageType: 0 
                  })
                })
              }
            } catch (err) {
              console.log(err)
              this.errlog = err.message;
            }
            this.$message({
              type: 'success',
              message: '办理成功'
            })
            if (this.form.userId) {
              this.$router.push({
                name: 'videoflowbagSuccess'
              })
            } else {
              this.$router.push({
                name: 'videoflowbagCommonSuccess'
              })
            }
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="less" scope>
.container{
  background: rgb(65, 201, 154);
  padding-bottom: 3.5rem;
}
.header{
  .banner{
    width: 100%;
  }
}
.module-bg{
  width: 90%;
  margin: 0 auto;
  border: 2px solid #48c89f;
  border-radius: 6px;
  padding: 6px;
  background-color: #ffffff;
}
.mobile-form{
  padding: 0 48px;
  margin-top: -160px;
}
.packages-form{
  .packages-info{
    >ul{
      display: flex;
      >li{
        flex: 1;
        font-size: .8rem;
        font-weight: bold;
        background-color: #f5f3f3;
        margin: .4rem;
        border-radius: 12px;
        >div{
          margin: .8rem .2rem;
        }
        .name{
          color: #e69a79;
        }
        .desc{
          color: #888;
        }
        &.selected{
          background-color: #88f3d1;
          .name{
            color: #e75e25;
          }
          .desc{
            color: #333;
          }
        }
      }
    }
    .tips{
      margin: 6px;
      font-size: .8rem;
      text-align: left;
      .tip{
        margin: 3px 0;
        i{
          color: #48c89f;
        }
      }
    }
  }
}
.user-notice{
  margin-top: 12px;
  font-size: .8rem;
  color: #222;
  .title{
    color: #48c89f;
    font-size: 1rem;
  }
  .content{
    text-align: left;
    margin: 6px;
    ul{
      margin-left: .4rem;
    }
  }
}
.dialog-content{
  text-align: left;
  .mobile-info{
    color: #333;
    font-weight: bold;
  }
  .package-info{
    color: #e75e25;
    font-weight: bold;
  }
}
.share-ad{
  text-align: center;
  color: #a3a3a3;
  font-size: .9rem;
  img{
    width: 94%;
  }
}
.share-dialog{
  position: fixed;
  z-index: 10;
  top: 0px;
  right: 0px;
  background-color: rgba(0,0,0,.8);
  width: 100%;
  height: 900px;
}
.bottom{
  width: 70%;
  // z-index: 9;
  // position: fixed;
  // bottom: 0;
  margin: 0 auto;
  margin-top: 1rem;
  margin-bottom: 7rem;
  height: 2.9rem;
  button{
    width: 100%;
    border-radius: 0;
    font-size: 1.3rem;
    border-radius: 36px;
    box-shadow: 0 3px 3px #a3a3a3;
  }
}
.share-infos{
  color: #a3a3a3;
  font-size: .5rem;
}
.img-desc{
  margin: 0 1.2rem;
  margin-top: 2.6rem;
  img{
    width: 100%;
  }
}
.notice{
  position: relative;
  &:after{
    position: absolute;
    background: url('../../../public/images/shaanxi/title.png') no-repeat;
    background-size: 100%;
    content: '';
    width: 14rem;
    height: 4rem;
    left: 50%;
    top: -1.1rem;
    margin-left: -7rem;
  }
  background-color: #fff;
  border-radius: .4rem;
  text-align: left;
  padding: 1.5rem .8rem .6rem;
  margin: 0 1.2rem;
  margin-top: 2.6rem;
  font: "黑体", "Arial";
  ul{
    margin-top: 1rem;
    li{
      clear: both;
      overflow: hidden;
      font-size: .8rem;
      color: #4A9F94;
      margin-bottom: .2rem;
      .num{
        float: left;
        width: 1.4rem;
        line-height: 1.2rem;
      }
      .content{
        line-height: 1.2rem;
        margin-left: 1.3rem;

      }
    }
  }
}
.el-form-item {
  margin-bottom: .4rem;
}
</style>